import React from "react";
import style from "./CoreValueCard.module.css";
import truncateIfLong1 from "../../utilities/truncateIfLong1";

function CoreValueCard({ data }) {

    return(

        <div className={style.CoreValueCard_container} data-aos="zoom-in" data-aos-duration="1200" data-aos-offset="80">
            <div className={style.valueCardImgContainer}>
                <img src={data.icon} alt={data.heading} />
            </div>
            <div>
                <h1>{data.heading}</h1>
                <p title={data?.content}>{data?.content}</p>
            </div>
        </div>
    );
}

export default CoreValueCard;